module.exports = "/fonts/ElevanceSans-Semibold.7a34f5a3a12984e64935db2ce46d8b82.woff";